import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEraser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"eraser, rubber, clean-up"} maskId="square-filled-radius-0-stroke-1-IconEraser"><path fillRule="evenodd" clipRule="evenodd" d="M14.52 2.28723L21.6938 10.0128L10.7067 21H7.29245L1.28516 14.9927L14.52 2.28723ZM2.71395 15.0073L7.70666 20H10.2924L12.292 18.0005L6.06529 11.79L2.71395 15.0073Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconEraser;
